import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Box, Popover, Typography, Button, Divider, IconButton } from '@mui/material';
import {Flag as ReportIcon} from 'react-feather';
import { fetchFaultyCount } from 'src/actions/faultyCountActions'; // axios-thunk
import { useNavigate } from 'react-router';

const FaultyCount = () => {
  const dispatch = useDispatch();
  const faultyCount = useSelector(state => state.faultyCount); // direkt i state
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchFaultyCount());
  }, [dispatch]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Badge
        badgeContent={(faultyCount?.faultyMasters + faultyCount?.resettedSensors + faultyCount?.lossProperties) || 0}
        color={faultyCount?.faultyMasters + faultyCount?.resettedSensors > 0 ? "error" : "white"}
      >
        <IconButton onClick={handleOpen} size="large" color="inherit">
          <ReportIcon
            sx={{
              fontSize: 30
            }}
          />
        </IconButton>
      </Badge>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { p: 2.5, width: 320, borderRadius: 3 } }}
      >
        <Box>
            <Typography variant="h6" sx={{ mb: 0.5 }}>
            Systemstatus
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Översikt av eventuella problem
            </Typography>

            <Divider sx={{ mb: 2 }} />

            {(faultyCount?.faultyMasters === 0 && faultyCount?.resettedSensors === 0 && faultyCount?.lossProperties === 0) && (
            <Box sx={{ textAlign: 'center', py: 2 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                Allt ser bra ut!
                </Typography>
            </Box>
            )}

            {(faultyCount?.faultyMasters > 0 || faultyCount?.resettedSensors > 0 || faultyCount?.lossProperties > 0) && (
            <>
                {faultyCount?.faultyMasters > 0 && (
                <Box>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {faultyCount.faultyMasters} {faultyCount.faultyMasters > 1 ? "mastrar" : "master"} behöver åtgärdas
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    Kontrollera status och åtgärda problem med dessa mastrar.
                    </Typography>

                    <Button
                    fullWidth
                    variant="contained"
                    color="warning"
                    onClick={() => {
                        handleClose();
                        navigate("/app/masterstatuses");
                    }}
                    >
                    Visa mastrar
                    </Button>
                </Box>
                )}

                {faultyCount?.resettedSensors > 0 && (
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {faultyCount.resettedSensors} {faultyCount.resettedSensors > 1 ? "sensorer" : "sensor"} har återställts
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    Dessa sensorer har rapporterat lägre värden än tidigare.
                    </Typography>

                    <Button
                    fullWidth
                    variant="contained"
                    onClick={() => {
                        handleClose();
                        navigate("/app/sensorstatus");
                    }}
                    >
                    Visa sensorer
                    </Button>
                </Box>
                )}

                {faultyCount?.lossProperties > 0 && (
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {faultyCount.lossProperties} {faultyCount.lossProperties > 1 ? "fastigheter" : "fastighet"} har elpris lägre än spotpris
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    Dessa fastigheter har ett elpris i prislistan lägre än det genomsnittliga spotpriset.
                    </Typography>
                </Box>
                )}
            </>
            )}
        </Box>
      </Popover>
    </>
  );
};

export default FaultyCount;